<lcp-header [isInverted]="true"></lcp-header>

<ng-container *ngIf="fields">
  <section class="home-hero-section">
    <!-- [style.background-image]="lcpHelper.backgroundImageFromMedia(bannerImage)"> -->

    <img class="home-hero-banner-img" [src]="lcpHelper.urlFromMedia(bannerImage)" fetchpriority="high">
    
    <div class="home-hero-section-shroud">
    </div>

    <div *ngIf="displayArrowContainer"
      class="home-hero-scroll-icon-wrapper">
      <a class="home-hero-scroll-icon-container"
        (click)="handleSelectScrollArrow($event)"
        [class.is-hidden]="!displayArrow">
        <img class="home-hero-scroll-icon" 
          height="42px"
          width="27px"
          [src]="lcpHelper.urlFromMedia(scrollArrowIcon)">
      </a>
    </div>


    <div class="flex-10a" ></div>
    <div class="home-hero-section-content-container" >
      <div class="home-hero-section-content-container-inner" >
        <div class="home-hero-section-content lcp-section-content" >
          <!-- <div class="flex-10a"></div> -->
          <div class="home-tagline-container">
            <div class="home-tagline-spacer-top"></div>
            <div class="home-tagline-container-line-1">
              <h3 #heroMessageLine1
                class="home-tagline home-tagline--lowercase line-1"
                [class.should-display-cursor]="shouldDisplayTagline[0]"></h3>  
            </div>
            <div class="home-tagline-container-line-2"
              #heroMessageLine2Container>
              <h1 #heroMessageLine2
                class="home-tagline line-2 tagline-is-hidden"
                [class.home-tagline--uppercase]="taglineUppercase"
                [class.home-tagline--lowercase]="taglineLowercase"
                [class.should-display-cursor]="shouldDisplayTagline[1]"></h1>  
            </div>
            <div class="home-tagline-spacer-bottom"></div>
          </div>
        </div>
        <!-- <div class="flex-10a"></div> -->
      </div>
    </div>
    <div class="flex-10a" ></div>
  </section>
  
  <section class="lcp-section" *ngFor="let section of fields['sections']"
    [ngClass]="'lcp-' + section.fields['slug']"
    [class.is-inverted]="section.fields['inverted']">

    <div class="lcp-section-content"
      [ngClass]="'home-section--' + section.fields['slug']">

      <div *ngIf="section.fields['title']"
        class="home-section-title-container">
        <h2 class="home-section-title">
          {{ section.fields['title'] }}
        </h2>
      </div>

      <ng-container *ngIf="section.fields['slug'] == 'home-intro'">
        <ng-content *ngTemplateOutlet="introSection; context:{ section: section }"></ng-content>
      </ng-container>

      <ng-container *ngIf="section.fields['slug'] == 'home-projects'">
        <ng-content *ngTemplateOutlet="projectsSection; context:{ section: section }"></ng-content>
      </ng-container>

      <ng-container *ngIf="section.fields['slug'] == 'home-clients-v2'">
        <ng-content *ngTemplateOutlet="clientsSection; context:{ section: section }"></ng-content>
      </ng-container>

      <ng-container *ngIf="['home-intro','home-projects','home-clients-v2'].indexOf(section.fields['slug']) < 0">
        <code>FORMATTING NEEDED: {{ section.fields['slug'] }}</code>
      </ng-container>
    
    </div>
  </section>  
</ng-container>


<ng-template #introSection let-section="section">
  <div class="home-section-intro-content-container" *ngFor="let content of section.fields['items']; index as contentIndex">
    <!-- <div class="flex-10a"></div> -->
    
    <div class="display-flex">
      <!-- <div class="lcp-subheading is-color-teal is-color-1 flex-50-not-sm"
        [innerHtml]="lcpHelper.htmlFromRichText(content.fields['body'])">
      </div> -->

      <lcp-rich-text *ngIf="content.fields['body']" 
        class="lcp-subheading is-color-teal is-color-1 flex-50-not-sm"
        [document]="content.fields['body']">
      </lcp-rich-text>
    </div>
  </div>
</ng-template>


<ng-template #projectsSection let-section="section">
  <div class="home-section-projects-content-container" *ngFor="let content of section.fields['items']; index as contentIndex">
    <!-- <div class="flex-10a"></div> -->

    <div class="home-projects-content">
      <div class="home-block-title-container">
        <h4 *ngIf="content.fields['title']" class="home-block-title">
          {{ content.fields['title'] }}
        </h4>
      </div>

      <lcp-rich-text *ngIf="content.fields['body']" 
        class="lcp-section-content-body"
        [document]="content.fields['body']">
      </lcp-rich-text>
    </div>

    <!-- *ngIf="content.fields['media']"  -->
    <div 
    class="lcp-section-content-media-container">

      <!-- <ng-container *ngFor="let media of content.fields['media']; index as mediaIndex"> -->
      <div class="home-projects-container">
        <!-- <div class="home-project" *ngFor="let project of projects; index as mediaIndex"> -->
        <div class="home-project" *ngFor="let project of content.fields['items']; index as mediaIndex">

          <!-- <div class="home-project"> -->
          <a class="project-preview-container"
            [routerLink]="projectPath(project)">

            <!-- <img *ngIf="project.fields['media'][0]"
                class="home-project-image"
                [src]="urlFromMedia(project.fields['media'][0])"> -->

            <div class="project-preview-image-container"
              *ngIf="project.fields['media']">
              <!-- {{ projectPath(project) }} -->
              <img *ngIf="project.fields['media'][0]"
              class="project-preview-cover-image"
              [src]="urlFromMedia(project.fields['media'][0])">

              <div class="project-preview-overlay">
                <div class="project-preview-overlay-content">
                  <div class="flex-10a"></div>
                  <div class="project-preview-overlay-title">
                    {{ project.fields['title'] }}
                  </div>
                  <div class="project-preview-overlay-tagline txt-lowercase"
                    *ngIf="project.fields['tagline']"
                    [innerHtml]="lcpHelper.htmlFromRichText(project.fields['tagline'])">
                    <!-- {{ project.fields['tagline'] }}</div> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="project-preview-title-sm hover-after">
              {{ project.fields['title'] }}
            </div>
            <!-- <div class="home-project-image" [style.background-image]="'url(' + lcpHelper.srcFromMedia(media) + ')'"></div> -->
            <!-- <img class="home-project-image" [src]="lcpHelper.srcFromMedia(media)"> -->
            <!-- <div class="carousel__image" [style.background-image]="'url(' + src + ')'"></div> -->
          </a>
        </div>

        <!-- <div #lottiePlayerContainer
          [ngClass]="['lottie-player-container', 'lottie-player-container_' + contentIndex + '_' + mediaIndex]"
          *ngIf="media.fields['file'] && media.fields['file']['contentType'] === 'application/json'">

          <lottie-player #lottiePlayer
            [ngClass]="['lottie-player', 'lottie-player_' + contentIndex + '_' + mediaIndex]"
            [src]="'https://' + media.fields['file'].url"
            (ready)="handlePlayerReady($event, contentIndex + '_' + mediaIndex)"
            (load)="handlePlayerLoad($event)">
          </lottie-player>
        </div> -->
      <!-- </ng-container> -->
      </div>
    </div>

  </div>
</ng-template>


<ng-template #clientsSection let-section="section">
  <div #clientLogoIntersection
    class="home-client-intersection"></div>

  
  <div class="lcp-section-content-container" *ngFor="let content of section.fields['items']; index as contentIndex">
    <div *ngIf="content.fields['media']" 
      #clientLogos
      class="lcp-section-content-media-container">

      <!-- LOGO CAROUSEL -->
      <lcp-carousel 
        [options]="{ defer: true }"
        [media]="content.fields['media']"
        (onInit)="handleCarouselInit($event)"
        [slideCount]="clientLogoCount">
      </lcp-carousel>
    </div>

    <div class="home-client-text-container">
      <div class="home-client-text">
        <div class="home-block-title-container">
          <h4 *ngIf="content.fields['title']" class="home-block-title">
            {{ content.fields['title'] }}
          </h4>
        </div>

        <lcp-rich-text *ngIf="content.fields['body']" 
          class="lcp-subheading is-color-2"
          [document]="content.fields['body']">
        </lcp-rich-text>
      </div>
    </div>
  </div>
</ng-template>